function getConfigValue(value: unknown): string {
    if (typeof value !== 'string') {
        return ''
    }

    return value.trim()
}

function isLocalHost(hostname: string): boolean {
    return hostname === 'localhost' || hostname === '127.0.0.1'
}

function isPlatformHost(hostname: string): boolean {
    return hostname === 'lilaliba.com' || hostname === 'admin.lilaliba.com'
}

function normalizeStorefrontHost(hostname: string): string {
    if (hostname.startsWith('www.')) {
        return hostname.slice(4)
    }

    return hostname
}

export function useApiBaseURL(): string {
    const config = useRuntimeConfig()
    const url = useRequestURL({xForwardedHost: true, xForwardedProto: true})
    const hostname = url.hostname.toLowerCase()
    const apiPath = getConfigValue(config.public.API_PATH)
    const platformApiPath = getConfigValue(config.public.PLATFORM_API_PATH)

    if (isLocalHost(hostname)) {
        if (apiPath) {
            return apiPath
        }

        return `${url.protocol}//${hostname}:3001`
    }

    if (isPlatformHost(hostname)) {
        if (platformApiPath) {
            return platformApiPath
        }

        if (apiPath) {
            return apiPath
        }

        return `${url.protocol}//api.lilaliba.com`
    }

    // other platform hosts, e.g. dev.lilaliba.com on Railway, name their API explicitly
    if (apiPath) {
        return apiPath
    }

    const storefrontHost = normalizeStorefrontHost(hostname)
    return `${url.protocol}//api.${storefrontHost}`
}
